import * as React from "react";
import {useState} from "react";
import {ApiService} from "../services/ApiService";
import {ApiResponse, getErrorMessagesFromResponse, getMessageText} from "../models/ApiResponse";
import {LoaderSpinner} from "./LoaderSpinner";
import {DATE_TIME_OPTIONS, timestampToString} from "../helpers/Date";

interface ReadButtonProps {
    text: string,
    tag: string,
    done: boolean,
    timestamp: number
}

export default function ReadButton(props: ReadButtonProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [done, setDone] = useState<boolean>(props.done);
    const [timestamp, setTimestamp] = useState<number>(props.timestamp);
    const apiService: ApiService = new ApiService();

    const createRead = () => {
        setLoading(true);
        setError('');
        apiService.post('create_read_button', {tag: props.tag}).then((apiResponse: ApiResponse) => {
            setTimestamp(apiResponse.response.data.readButton.timestamp);
            setDone(true);
            setLoading(false);
        }).catch(reason => {
            console.log(reason);
            const msg = getMessageText(getErrorMessagesFromResponse(reason));
            setError(msg ? msg : 'Es ist ein unerwarteter Fehler aufgetreten');
            setLoading(false);
        });
    };

    return <div>
        {loading ? (
            <LoaderSpinner/>
        ) : (
            <>
                {done ? (
                    <div>
                        Sie haben am {timestampToString(timestamp * 1000, DATE_TIME_OPTIONS)} folgende
                        Bestätigung abgegeben: {props.text}
                    </div>
                ) : (
                    <div style={{textAlign: 'center'}}>
                        <button onClick={createRead}>
                            {props.text}
                        </button>
                    </div>
                )}
            </>
        )}

        {error && (
            <div className={"errorMessage"}>
                {error}
            </div>
        )}
    </div>;
}
